export class GetObjectStoreScanMethodResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "objectStoreScanMethod",
            "baseName": "objectStoreScanMethod",
            "type": "ObjectStoreScanMethod",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetObjectStoreScanMethodResponse.attributeTypeMap;
    }
    constructor() {
    }
}
